/**
 * @generated SignedSource<<3a580eedd8cb5583cc8ff7ec59031156>>
 * @relayHash 711fb677962232e5694d9a5b690a640c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8625c0011579bb3b9b5a9db149cdc9fa8d9211e559b74bfe288f6299780a44fe

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { pageLayout_projectsDirectoryLayout_RootQuery } from './pageLayout_projectsDirectoryLayout_RootQuery.graphql';

const node: PreloadableConcreteRequest<pageLayout_projectsDirectoryLayout_RootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8625c0011579bb3b9b5a9db149cdc9fa8d9211e559b74bfe288f6299780a44fe",
    "metadata": {},
    "name": "pageLayout_projectsDirectoryLayout_RootQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
